import { AMAZON_CONNECT_ARTICLE_ID } from '@constants/book-request'

// Re-exported for the router guard in index.js; single source lives in constants.
export { AMAZON_CONNECT_ARTICLE_ID }
export const AMAZON_CONNECT_BOOK_REQUEST_ENABLED = `${process.env.VUE_APP_AMAZON_CONNECT_BOOK_REQUEST_ENABLED}`.toLowerCase() === 'true'

export default [{
  path: '/',
  name: 'home',
  component: () => lazyLoadView(
    import('@views/home'),
  ),
},
{
  path: '/screen/:screenId',
  name: 'screen',
  component: () => lazyLoadView(
    import('@views/screen-builder'),
  ),
},
{
  path: '/zendesk-article/:articleId',
  name: 'articles',
  component: () => lazyLoadView(
    import('@views/articles'),
  ),
},
// Must precede '/article-builder/:articleId' so the exact path wins on cold load.
...(AMAZON_CONNECT_BOOK_REQUEST_ENABLED && AMAZON_CONNECT_ARTICLE_ID
  ? [{
    path: `/article-builder/${AMAZON_CONNECT_ARTICLE_ID}`,
    name: 'book-request-ac',
    component: () => lazyLoadView(
      import('@views/book-request-ac-view'),
    ),
  }, {
    path: '/book-request-submitted',
    name: 'book-request-ac-success',
    component: () => lazyLoadView(
      import('@views/book-request-ac-success-view'),
    ),
  }]
  : []),
{
  path: '/article-builder/:articleId',
  name: 'zendesk-articles',
  component: () => lazyLoadView(
    import('@views/article-builder'),
  ),
},
{
  path: '/article-builder-generic/:articleId',
  name: 'zendesk-articles-generic',
  component: () => lazyLoadView(
    import('@views/article-builder-generic'),
  ),
},
{
  path: '/got-it',
  name: 'gotIt',
  component: () => lazyLoadView(
    import('@widgets/Confirmation'),
  ),
},
{
  path: '/rate-us',
  name: 'rateUs',
  component: () => lazyLoadView(
    import('@widgets/RatingFS'),
  ),
},
{
  path: '/404',
  name: '404',
  component: require('@views/404').default,
  props: true,
},
// Unmatched routes -> 404.
{
  path: '*',
  redirect: '404',
},
]

// Lazy-loads a view with a loading + timeout fallback. NOTE: views loaded this
// way have no in-component route guards (beforeRouteEnter/Update/Leave) — use
// route-level guards instead.
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@views/loading').default,
    delay: 400, // ms before showing the loading view
    timeout: 10000, // ms before giving up
  })

  return Promise.resolve({
    functional: true,
    render(h, {
      data,
      children,
    }) {
      // Pass props/children through to the view.
      return h(AsyncHandler, data, children)
    },
  })
}
